import { useQuery } from "@tanstack/react-query";
import { useAuthFetch } from "@/hooks/use-data";
import type { EventoAuditoria } from "@shared/auditoria-frases";

export type EventoComFrase = EventoAuditoria & { frase: string };

export type ParamsEventos = {
  categoria?: string;
  q?: string;
  autor?: string;
  de?: string;
  ate?: string;
  empresaId?: string;
  entidade?: string;
  entidadeId?: string;
  page?: number;
};

export const AUDITORIA_EVENTOS_KEY = "/api/auditoria/eventos";

export function qsEventos(p: ParamsEventos): string {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) {
    if (v !== undefined && v !== "" && !(k === "page" && v === 1)) s.set(k, String(v));
  }
  return s.toString();
}

export function useAuditoriaEventos(params: ParamsEventos) {
  const authFetch = useAuthFetch();
  return useQuery<{ data: EventoComFrase[]; total: number; page: number; limit: number }>({
    queryKey: [AUDITORIA_EVENTOS_KEY, params],
    queryFn: () => {
      const qs = qsEventos(params);
      return authFetch(`${AUDITORIA_EVENTOS_KEY}${qs ? `?${qs}` : ""}`);
    },
    // auditoria_eventos não está na publicação Realtime: atualiza por polling
    refetchInterval: 15000,
  });
}
